var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"promotionTitle notranslate"},[_vm._v(_vm._s(_vm.typeToLocale(this.$route.params.type)))]),_c('PhotoGrid',{attrs:{"lang":_vm.lang,"locale":_vm.locale,"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }